import React from "react";
import * as moment from 'moment'
import {
  Theme,
  makeStyles,
  useTheme,
} from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { useBestOf } from "../../context/BestOf";
import settings from "../../../../settings";
import { AiOutlineDrag, AiTwotoneDelete } from "react-icons/ai";
import { GiBookCover } from "react-icons/gi";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
      display: "flex",
      marginBottom: 15,
      borderRadius: 5,
    },
    details: {
      display: "flex",
      flexDirection: "column",
      width: "66%",
    },
    content: {
      flex: "1 0 auto",
      padding: 0,
    },
    cover: {
      width: "33%",
    },
    controls: {
      display: "flex",
      alignItems: "center",
      paddingLeft: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      justifyContent: "center",
      padding: 0,
    },
    playIcon: {
      height: 38,
      width: 38,
    },
    itemPublishedDate: { 
      fontSize: "12px",
      margin: "8px 0",
    },
    titleArticle: {
      textDecoration: "none",
      color: theme.palette.text.secondary,
      display: "block",
      marginTop: "16px"
    }
  })
);

const DragableItem = ({ day, item }: any) => {
  const classes = useStyles();
  const theme = useTheme();
  const { state, dispatch } = useBestOf();

  return (
    <Card elevation={10} className={classes.root}>
      <CardMedia
        className={classes.cover}
        image={item.feature_image}
        title={"image-" + item.feature_image}
      />
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography variant="subtitle1" color="textSecondary">
            <a target="_blank" rel="noopener noreferrer" href={`${settings.bestOfArticlePath}/${item.slug}`} className={classes.titleArticle}>
              {item.title}
            </a>
            <p className={classes.itemPublishedDate}>publié le: {moment.utc(item.published_at).format('DD/MM/YYYY - hh:mm')}</p>
          </Typography>
        </CardContent>
        <div className={classes.controls}>
            {(day) ?
            <>
              <IconButton title="Supprimer l'article" onClick={() => {
                dispatch({type: 'REMOVE_ARTICLE_POST_DAY', payload: { day, post: item }});
                dispatch({type: 'REMOVE_ARTICLE_COVER', payload: { post: item }});
              }}>
                <AiTwotoneDelete color={theme.palette.primary.dark} size={25} />
              </IconButton>
              {
                state.postCover.filter((post) => post.slug === item.slug).length === 0 &&
                <IconButton
                  title="Ajouter l'article en couverture"
                  disabled={(state.postCover.length >= 4) ? true : false}
                  style={(state.postCover.length >= 4) ? 
                    {
                      color: "inherit", 
                      cursor: "not-allowed",
                      opacity: 0.4,
                      textDecoration: "none",
                    } : {}}
                  onClick={() => dispatch({type: 'ADD_ARTICLE_COVER', payload: { post: item }})}>
                    <GiBookCover color={theme.palette.primary.dark} size={25} />
                </IconButton>
              }
            </>
            :
            <IconButton title="Supprimer la couverture" onClick={() => dispatch({type: 'REMOVE_ARTICLE_COVER', payload: { post: item }})}>
              <AiTwotoneDelete color={theme.palette.primary.dark} size={25} />
            </IconButton>
          }
          <a href="#drag">
            <IconButton title="Trier les articles du jour">
              <AiOutlineDrag color={theme.palette.primary.dark} size={25} />
            </IconButton>
          </a>
        </div>
      </div>
    </Card>
  );
};

export default DragableItem;
